import { useMemo } from 'react';
import { useAuthStore } from '../stores/authStore';

/** Matches countries.soi = 1 (plus common user.country variants). */
const SOI_COUNTRY_HINTS = [
  'armenia',
  'azerbaijan',
  'bulgaria',
  'georgia',
  'greece',
  'iran',
  'iraq',
  'pakistan',
  'russian federation',
  'russia',
  'türkiye',
  'turkiye',
  'turkey',
];

function guessSoiFromCountry(country?: string | null): boolean {
  if (!country) return false;
  const c = country.toLowerCase();
  return SOI_COUNTRY_HINTS.some((h) => c.includes(h));
}

/**
 * Same UI for all countries; only welcome copy differs.
 * Admins always use RISP (never SOI), even if their profile country is SOI-flagged.
 */
export function useRispProgram() {
  const { user } = useAuthStore();
  const isAdmin = user?.role?.toLowerCase() === 'admin';
  const isSoi = useMemo(() => {
    if (isAdmin) return false;
    return user?.role?.toLowerCase() === 'soi' || guessSoiFromCountry(user?.country);
  }, [isAdmin, user?.role, user?.country]);
  return { isSoi, isAdmin, loading: false, country: user?.country || '' };
}
